import { LocationStrategy } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'ups-success-screen',
    templateUrl: './success-screen.component.html',
    styleUrls: ['./success-screen.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SuccessScreenComponent {
  public caseReference: string | null = '';

  constructor(private location: LocationStrategy, private router: Router, private route: ActivatedRoute) {
    history.pushState(null, '', window.location.href);
    this.location.onPopState(this.listener);

    this.caseReference = this.route.snapshot.paramMap.get('id');
  }

  public createCases(): void {
    this.router.navigate(['/case']);
  }

  public listener(): () => void {
    return () => {
      history.pushState(null, '', window.location.href);
    };
  }
}
